// AUTO-GENERATED by a one-off migration script - do not hand-edit individual entries lightly.
// Ported from UnmanagedApi/src/functions/*.ts (the api-key-based middle layer this bypasses),
// so each builder mirrors that function's exact downstream path construction against
// ClientDataAPI_WS. Regenerate rather than patch if UnmanagedApi's routing for one of these
// ever changes upstream.
import ENDPOINTS from '@models/Endpoint';

export type DirectRouteBuilder = (params: any, filterDates: any) => string;

export const DIRECT_ROUTE_BUILDERS: Partial<Record<ENDPOINTS, DirectRouteBuilder>> = {
  [ENDPOINTS.ADM_COURSEINFOCLASSID]: (params, filterDates) => {
    const fromdate = filterDates?.fromDate
    const todate = filterDates?.toDate
    let filter = `/${fromdate}/${todate}`;
    const classId = params?.classId
    return `ADM_CourseInfoClassId/${classId}${fromdate && todate ? filter : ""}`;
  },
  [ENDPOINTS.ADM_COURSEPERCENTAGEOVERTIME]: (params, filterDates) => {
    const fromdate = filterDates?.fromDate
    const todate = filterDates?.toDate
    let filter = `/${fromdate}/${todate}`;
    const classId = params?.classId
    const useMerit = params?.useMerit
    const usePause = params?.usePause
    return `ADM_CoursePercentageOverTime/${classId}/${useMerit}/${usePause}${fromdate && todate?filter:""}`;
  },
  [ENDPOINTS.ADM_STUDENTSPERCLASS_ID]: (params, filterDates) => {
    const fromdate = filterDates?.fromDate
    const todate = filterDates?.toDate
    let filter = `/${fromdate}/${todate}`;
    const classId = params?.classId
    const teacher_username = params?.teacher_username
    const note_type = params?.note_type
    const useMerit = params?.useMerit
    const usePause = params?.usePause
    return `ADM_StudentsPerClass_ID/${classId}/${teacher_username}/${note_type}/${useMerit}/${usePause}${fromdate && todate ? filter : ""}`;
  },
  [ENDPOINTS.APPROVEDENYREQUEST]: (params, filterDates) => {
    return `ApproveDenyRequest/`;
  },
  [ENDPOINTS.CALCULATEBADGES4STUDENT]: (params, filterDates) => {
    const studentId = params?.studentId
    const useMerit = params?.useMerit
    const usePause = params?.usePause
    return `CalculateBadges4Student/${studentId}/${useMerit}/${usePause}`;
  },
  [ENDPOINTS.CALCULATEMERITSTUDENTONCOURSE]: (params, filterDates) => {
    const fromdate = filterDates?.fromDate
    const todate = filterDates?.toDate
    let filter = `/${fromdate}/${todate}`;
    return `CalculateMeritStudentOnCourse/${fromdate && todate ? filter : ""}`;
  },
  [ENDPOINTS.CHECK4NOTFULLDAYS]: (params, filterDates) => {
    return `Check4NotFulldays`;
  },
  [ENDPOINTS.CHECKFORSTUDENTUPDATE]: (params, filterDates) => {
    const username = params?.username
    return `CheckForStudentUpdate/${username}`;
  },
  [ENDPOINTS.CHECKIFKOHORTEXISTS]: (params, filterDates) => {
    return `CheckIfKohortExists/`;
  },
  [ENDPOINTS.COUNTABSENCETAGS]: (params, filterDates) => {
    const fromDate = params?.fromDate
    const toDate = params?.toDate
    return `CountAbsenceTags/${fromDate}/${toDate}`;
  },
  [ENDPOINTS.COUNTABSENCETYPES]: (params, filterDates) => {
    const fromDate = params?.fromDate
    const toDate = params?.toDate
    return `CountAbsenceTypes/${fromDate}/${toDate}`;
  },
  [ENDPOINTS.COUNTACTIVEREGISTRATIONS]: (params, filterDates) => {
    return `CountActiveRegistrations/`;
  },
  [ENDPOINTS.CREATEABSENCEREQUEST]: (params, filterDates) => {
    return `CreateAbsenceRequest/`;
  },
  [ENDPOINTS.CREATEEVENTINQUEUE]: (params, filterDates) => {
    const object_id = params?.object_id
    const object_type = params?.object_type
    const event_id = params?.event_id
    const target_id = params?.target_id
    return `CreateEventInQueue/${object_id}/${object_type}/${event_id}/${target_id?target_id:""}`;
  },
  [ENDPOINTS.CREATELEAVEEVENT]: (params, filterDates) => {
    const student_id = params?.student_id
    const student_username = params?.student_username
    const author_id = params?.author_id
    const author_username = params?.author_username
    const tag_ids = params?.tag_ids
    const absence_type = params?.absence_type
    const registration_method = params?.registration_method
    return `CreateLeaveEvent/${student_id}/${student_username}/${author_id}/${author_username}/${tag_ids}/${absence_type}/${registration_method}`;
  },
  [ENDPOINTS.DELETEABSENCEREQUEST]: (params, filterDates) => {
    return `DeleteAbsenceRequest/`;
  },
  [ENDPOINTS.DELETEACTIVEREGISTRAIONS]: (params, filterDates) => {
    return `DeleteActiveRegistrations/`;
  },
  [ENDPOINTS.DELETEGUARDIAN4STUDENT]: (params, filterDates) => {
    return `DeleteGuardian4Student`;
  },
  [ENDPOINTS.DELETESICKEVENT4STUDENT]: (params, filterDates) => {
    const absence_id = params?.absence_id
    return `DeleteSickEvent4Student/${absence_id}`;
  },
  [ENDPOINTS.DELETESTUDENTNOTE]: (params, filterDates) => {
    const note_id = params?.note_id
    return `DeleteStudentNote/${note_id}`;
  },
  [ENDPOINTS.DELETEREWARD]: (params, filterDates) => {
    const id = params?.id
    return `Delete_Reward/${id}`;
  },
  [ENDPOINTS.GENERATEMERITLIST]: (params, filterDates) => {
    const username = params?.username
    const clientTimeZone = params?.clientTimeZone
    const useDepartment = params?.useDepartment
    return `GenerateMeritList/${username}/${clientTimeZone}/${useDepartment}`;
  },
  [ENDPOINTS.GETABSENCESPRDATE]: (params, filterDates) => {
    const fromdate = params?.fromdate
    const todate = params?.todate
    return `GetAbsencePrDate/${fromdate}/${todate}/`;
  },
  [ENDPOINTS.GETABSENCEREGISTRATIONS4DAY]: (params, filterDates) => {
    const student_id = params?.student_id
    const date = params?.date
    let timezone = params?.timezone
    return `GetAbsenceRegistrations4Day/${student_id}/${date}/${timezone?timezone:''}`;
  },
  [ENDPOINTS.GETABSENCEREQUESTS4APPROVAL]: (params, filterDates) => {
    const username = params?.username
    const fromDate = params?.fromDate
    let date = ""
    if(fromDate) date = "/" + fromDate
    return `GetAbsenceRequests4Approval/${username}${date}`;
  },
  [ENDPOINTS.GETABSENCEREQUESTS4PARENT]: (params, filterDates) => {
    return `GetAbsenceRequests4Parent/`;
  },
  [ENDPOINTS.GETALLBADGES]: (params, filterDates) => {
    const active = params?.active
    return `GetAllBadges/${active?active:""}`;
  },
  [ENDPOINTS.GETALLBADGES4STUDENT]: (params, filterDates) => {
    const studentId = params?.studentId
    return `GetAllBadges4Student/${studentId}`;
  },
  [ENDPOINTS.GETALLLESSONDAYS4STUDENT]: (params, filterDates) => {
    const studentId = params?.studentId
    const startDate = params?.startDate
    const endDate = params?.endDate
    return `GetAllLessonDays4Student/${studentId}/${startDate}/${endDate}`;
  },
  [ENDPOINTS.GETALLNOTE_TAGS]: (params, filterDates) => {
    return `GetAllNote_Tags`;
  },
  [ENDPOINTS.GETALLREGISTRATIONS]: (params, filterDates) => {
    const fromDate = params?.fromDate
    const toDate = params?.toDate
    const timezone = params?.timezone
    const daysback = params?.daysback
    const From_Filter = params?.From_Filter
    const To_Filter = params?.To_Filter
    const dateFilter = From_Filter && To_Filter ? `${From_Filter}/${To_Filter}` : '';
    return `GetAllRegistrations/${fromDate}/${toDate}/${timezone}/${daysback}/${dateFilter}`;
  },
  [ENDPOINTS.GETALLSTUDENTNOTES]: (params, filterDates) => {
    const student_sis_id = params?.student_sis_id
    const note_type = params?.note_type
    const clientTimeZone = params?.clientTimeZone
    const reader_username = params?.reader_username
    return `GetAllStudentNotes/${student_sis_id}/${reader_username}/${note_type}/${clientTimeZone}`;
  },
  [ENDPOINTS.GETASSIGNMENT]: (params, filterDates) => {
    const id = params?.id
    return `GetAssignment/${id}`;
  },
  [ENDPOINTS.GETASSIGNMENTBYTYPE]: (params, filterDates) => {
    return `GetAssignmentByType`;
  },
  [ENDPOINTS.GETASSIGNMENTINFO]: (params, filterDates) => {
    const id = params?.id
    return `GetAssignmentInfo/${id}`;
  },
  [ENDPOINTS.GETATTCOUNTER4USER]: (params, filterDates) => {
    const username = params?.username
    return `GetAttCounter4User/${username}`;
  },
  [ENDPOINTS.GETBADGES4STUDENT_Splash]: (params, filterDates) => {
    const studentId = params?.studentId
    const updateView = params?.updateView
    return `GetBadges4Student_Splash/${studentId}/${updateView}`;
  },
  [ENDPOINTS.GETCASEWORKERSTUDENTS]: (params, filterDates) => {
    const username = params?.username
    const note_type = params?.note_type
    const fromdate = filterDates?.fromDate
    const todate = filterDates?.toDate
    let filter = `/${fromdate}/${todate}`;
    const useMerit = params?.useMerit
    const usePause = params?.usePause
    return `GetCaseWorker_Students/${username}/${note_type}/${useMerit}/${usePause}${fromdate && todate?filter:""}`;
  },
  [ENDPOINTS.GETCOURSEABSENCEFORSTUDENT]: (params, filterDates) => {
    const fromdate = params?.fromdate
    const todate = params?.todate
    const studentid = params?.studentid
    return `GetCourseAbsenceForStudent/${fromdate}/${todate}/${studentid}`;
  },
  [ENDPOINTS.GETCOURSELIST]: (params, filterDates) => {
    const fromdate = filterDates?.fromDate
    const todate = filterDates?.toDate
    return `GetCourseList/${fromdate}/${todate}`;
  },
  [ENDPOINTS.GETCOURSES]: (params, filterDates) => {
    const fromDate = params?.fromDate
    const toDate = params?.toDate
    return `GetCourses/${fromDate}/${toDate}`;
  },
  [ENDPOINTS.GETCURRENTLOCALDATETIME]: (params, filterDates) => {
    const timezone = params?.timezone
    return `GetCurrentLocalDatetime/${timezone}`;
  },
  [ENDPOINTS.GETDEPARTMENTSETTINGS]: (params, filterDates) => {
    return `GetDepartmentSettings`;
  },
  [ENDPOINTS.GETEVENTINFO]: (params, filterDates) => {
    const listOfReservationIds = params?.listOfReservationIds
    const studentId = params?.studentId
    return `GetEventInfo/${listOfReservationIds}/${studentId}`;
  },
  [ENDPOINTS.GETFILTERS4USER]: (params, filterDates) => {
    const user_id = params?.user_id
    return `GetFilters4user/${user_id}/`;
  },
  [ENDPOINTS.GETGUARDIANS]: (params, filterDates) => {
    return `GetGuardians`;
  },
  [ENDPOINTS.GETINITIALREGISTRATIONS_TYPES]: (params, filterDates) => {
    return `GetInitialsRegistrations_Types`;
  },
  [ENDPOINTS.GETLEAVEINFO]: (params, filterDates) => {
    return `GetLeaveInfo/`;
  },
  [ENDPOINTS.GETLUDUSCASEWORKERREPORTSRECEPIENTS]: (params, filterDates) => {
    const login = params?.login
    return `GetLUDUS_CaseworkerReportsRecepients/${login}`;
  },
  [ENDPOINTS.GETMERITSTUDENTSBYTIMEBLOCKS]: (params, filterDates) => {
    return `GetMeritStudentByTimeBlocks/`;
  },
  [ENDPOINTS.GETNOTECOUNTS4STUDENT]: (params, filterDates) => {
    const Student_sis_id = params?.Student_sis_id
    const reader_username = params?.reader_username
    const note_type = params?.note_type
    return `GetNoteCounts4Student/${Student_sis_id}/${reader_username}/${note_type}`;
  },
  [ENDPOINTS.GETNOTESFORDASH]: (params, filterDates) => {
    const fromDate = params?.fromDate
    const toDate = params?.toDate
    return `GetNotesForDash/${fromDate}/${toDate}`;
  },
  [ENDPOINTS.GETNOTE_TAGS]: (params, filterDates) => {
    const interface_Name = params?.interface_Name
    return `GetNote_Tags/${interface_Name}`;
  },
  [ENDPOINTS.GETPAUSE4CLASS]: (params, filterDates) => {
    return `GetPause4Class`;
  },
  [ENDPOINTS.GETPAUSE4HEATMAP]: (params, filterDates) => {
    return `GetPause4HeatMap`;
  },
  [ENDPOINTS.GETPAUSE4STUDENTPERCLASS]: (params, filterDates) => {
    return `GetPause4StudentPerClass`;
  },
  [ENDPOINTS.GETPAUSE4STUDENTS]: (params, filterDates) => {
    return `GetPause4Students`;
  },
  [ENDPOINTS.GETPAUSE4TIMEBLOCK]: (params, filterDates) => {
    return `GetPause4Timeblock`;
  },
  [ENDPOINTS.GETPAUSE4TIMEBLOCKSALLDAYVIEW]: (params, filterDates) => {
    return `GetPause4TimeblocksAlldayView`;
  },
  [ENDPOINTS.GETPAUSESTUDENTBYTIMEBLOCKS]: (params, filterDates) => {
    return `GetPauseStudentByTimeBlocks/`;
  },
  [ENDPOINTS.GETREDEEMREWARDSLOG]: (params, filterDates) => {
    return `GetRedeemRewards_Log/`;
  },
  [ENDPOINTS.GETREPORTDATA_KILKENNY]: (params, filterDates) => {
    return `GetReportData_Kilkenny`;
  },
  [ENDPOINTS.GETREPOTDATA_LUDUS]: (params, filterDates) => {
    const fromdate = filterDates?.fromDate
    const todate = filterDates?.toDate
    let filter = `/${fromdate}/${todate}`;
    const studentId = params?.studentId
    return `GetReportData_LUDUS/${studentId}${fromdate && todate?filter:""}`;
  },
  [ENDPOINTS.GETREWARDS]: (params, filterDates) => {
    const language = params?.language
    return `GetRewards/${language}`;
  },
  [ENDPOINTS.GETSICKEVENT4STUDENT]: (params, filterDates) => {
    const userId = params?.userId
    const daysback = params?.daysback
    return `GetSickEvent4Student/${userId}/${daysback}`;
  },
  [ENDPOINTS.GETSICKEVENT4ALLSTUDENTS]: (params, filterDates) => {
    const daysback = params?.daysback
    return `GetSickEvent4AllStudents/${daysback}`;
  },
  [ENDPOINTS.GETSTUDENTABSENCEONCOURSE]: (params, filterDates) => {
    const fromdate = filterDates?.fromDate
    const todate = filterDates?.toDate
    return `GetStudentAbsenceOnCourse/${fromdate}/${todate}`;
  },
  [ENDPOINTS.GETSTUDENTABSENCEONCOURSEANDSUBJECT]: (params, filterDates) => {
    const fromdate = filterDates?.fromDate
    const todate = filterDates?.toDate
    return `GetStudentAbsenceOnCourseAndSubject/${fromdate}/${todate}`;
  },
  [ENDPOINTS.GETSTUDENTABSENCEREGISTRATIONS]: (params, filterDates) => {
    const fromdate = filterDates?.fromDate
    const todate = filterDates?.toDate
    let filter = `/${fromdate}/${todate}`;
    const studentId = params?.studentId
    return `GetStudentAbsenceRegistrations/${studentId}${fromdate && todate?filter:""}`;
  },
  [ENDPOINTS.GETSTUDENTABSENCEWITHPREDICTIONS]: (params, filterDates) => {
    const date = params?.date
    return `GetStudentAbsenceWithPredictions/${date}`;
  },
  [ENDPOINTS.GETSTUDENTROSTER]: (params, filterDates) => {
    const username = params?.username
    return `GetStudentRoster/${username}`;
  },
  [ENDPOINTS.GETSTUDENTROSTERLOG]: (params, filterDates) => {
    return `GetStudentRosterLog`;
  },
  [ENDPOINTS.GETSTUDENTS]: (params, filterDates) => {
    const fromDate = params?.fromDate
    const toDate = params?.toDate
    return `GetStudents/${fromDate}/${toDate}`;
  },
  [ENDPOINTS.GETSTUDENTSINFO]: (params, filterDates) => {
    const timezone = params?.timezone
    return `GetStudentsInfo/${timezone}`;
  },
  [ENDPOINTS.GETSUBJECTLIST]: (params, filterDates) => {
    const fromdate = filterDates?.fromDate
    const todate = filterDates?.toDate
    return `GetSubjectList/${fromdate}/${todate}`;
  },
  [ENDPOINTS.GETTIMEBLOCKSBYSTUDENTIDANDDATE]: (params, filterDates) => {
    const studentId = params?.studentId
    const date = params?.date
    return `GetTimeblocksByStudentIDAndDate/${studentId}/${date ?date:""}`;
  },
  [ENDPOINTS.GETTRANSACTIONLOG_COINS]: (params, filterDates) => {
    const studentId = params?.studentId
    const transaction_type = params?.transaction_type
    return `GetTransactionLog_Coins/${studentId}/${transaction_type}`;
  },
  [ENDPOINTS.GETTRANSACTIONLOG_COINSALLSTUDENTS]: (params, filterDates) => {
    const maxcount = params?.maxcount
    const transaction_type = params?.transaction_type
    return `GetTransactionLog_CoinsAllStudents/${transaction_type}/${maxcount}`;
  },
  [ENDPOINTS.GETTRANSACTIONLOG_STATS]: (params, filterDates) => {
    return `GetTransactionLog_Stats`;
  },
  [ENDPOINTS.GETTREND]: (params, filterDates) => {
    return `GetTrend/`;
  },
  [ENDPOINTS.GETUSERDETAILS]: (params, filterDates) => {
    return `GetUserDetails/`;
  },
  [ENDPOINTS.GETUSERINFO]: (params, filterDates) => {
    const username = params?.username
    return `getUserInfo/${username}`;
  },
  [ENDPOINTS.GET_USERSETTING]: (params, filterDates) => {
    const username = params?.username
    return `GetUser_Setting/${username}`;
  },
  [ENDPOINTS.GETUSERCLASSFAVORITES]: (params, filterDates) => {
    const username = params?.username
    return `getUser_Class_Favorites/${username}`;
  },
  [ENDPOINTS.GETUSERSTUDENTFAVORITES]: (params, filterDates) => {
    const fromdate = filterDates?.fromDate
    const todate = filterDates?.toDate
    const username = params?.username
    const teacher_name = params?.teacher_name
    const note_type = params?.note_type
    const useMerit = params?.useMerit
    const usePause = params?.usePause
    let filter = `/${fromdate}/${todate}`;
    return `getUser_Student_Favorites/${username}/${teacher_name}/${note_type}/${useMerit}/${usePause}${fromdate && todate ? filter : ""}`;
  },
  [ENDPOINTS.GETUSERTEACHERFAVORITES]: (params, filterDates) => {
    const username = params?.username
    return `getUser_Teacher_Favorites/${username}`;
  },
  [ENDPOINTS.GET_TOKEN]: (params, filterDates) => {
    const clientId = params?.clientId
    const token = params?.token
    return `get_token/${clientId}/${token}`;
  },
  [ENDPOINTS.GUARDIANGETSTUDENTS]: (params, filterDates) => {
    const guid = params?.guid
    return `guardian_getstudents/${guid?guid:''}`;
  },
  [ENDPOINTS.ISREWARDREDEEMED]: (params, filterDates) => {
    return `IsRewardRedeemed/`;
  },
  [ENDPOINTS.KOHORTGETPERCENTAGES]: (params, filterDates) => {
    return `KohortGetPercentages/`;
  },
  [ENDPOINTS.LISTCOURSESFORSTUDENT]: (params, filterDates) => {
    const student_id = params?.student_id
    const daysback = params?.daysback
    return `ListCoursesForStudent/${student_id}/${daysback}`;
  },
  [ENDPOINTS.LISTKOHORTS]: (params, filterDates) => {
    const fromdate = filterDates?.fromDate
    const todate = filterDates?.toDate
    return `ListKohorts/${fromdate}/${todate}`;
  },
  [ENDPOINTS.MAKEREWARDRESERVATION]: (params, filterDates) => {
    return `MakeReward_Reservation/`;
  },
  [ENDPOINTS.MAKETRANSACTION_COINS]: (params, filterDates) => {
    const studentId = params?.studentId
    const transaction_type = params?.transaction_type
    const amount = params?.amount
    const username = params?.username
    return `MakeTransaction_Coins/${studentId}/${transaction_type}/${amount}/${username}`;
  },
  [ENDPOINTS.MERGELOGIN]: (params, filterDates) => {
    return `MergeLogin/`;
  },
  [ENDPOINTS.MODIFYREWARD]: (params, filterDates) => {
    return `Modify_Reward/`;
  },
  [ENDPOINTS.POSTREQUEST]: (params, filterDates) => {
    const requestmethod = params?.requestmethod
    return `${requestmethod}`;
  },
  [ENDPOINTS.REDEEMREWARD]: (params, filterDates) => {
    return `Redeem_Reward/`;
  },
  [ENDPOINTS.REGICHECKFORCHANGES]: (params, filterDates) => {
    return `Regi_CheckForChanges/`;
  },
  [ENDPOINTS.REGI_GETCOURSENAMEBYTIMEBLOCKID]: (params, filterDates) => {
    const timeblockID = params?.timeblockID
    return `Regi_GetCourseNameByTimeblockID/${timeblockID}`;
  },
  [ENDPOINTS.REGI_GETCOURSESBYCOURSENAME]: (params, filterDates) => {
    const date = params?.date
    return `Regi_GetCoursesByCourseName/${date}`;
  },
  [ENDPOINTS.REGI_GETCOURSESBYSTUDENTNAME]: (params, filterDates) => {
    const userName = params?.userName
    const formattedDate = params?.formattedDate
    const useMerit = params?.useMerit
    const usePause = params?.usePause
    return `Regi_GetCoursesByStudentName/${userName}/${formattedDate}/${useMerit}/${usePause}`;
  },
  [ENDPOINTS.REGI_GETCOURSESBYTEACHERNAME]: (params, filterDates) => {
    const userName = params?.userName
    const formattedDate = params?.formattedDate
    const formattedDate2 = params?.formattedDate2
    return `Regi_GetCoursesByTeacherName/${userName}/${formattedDate}/${formattedDate2}`;
  },
  [ENDPOINTS.REGI_GETREGISTRATIONLOG]: (params, filterDates) => {
    const sis_id = params?.sis_id
    const timeblock_id = params?.timeblock_id
    const timezone = params?.timezone
    return `Regi_GetRegistrationLog/${sis_id}/${timeblock_id}/${timezone}`;
  },
  [ENDPOINTS.REGI_GETREGISTRATIONOVERVIEW]: (params, filterDates) => {
    const timeblock_id = params?.timeblock_id
    return `Regi_GetRegistrationOverView/${timeblock_id}`;
  },
  [ENDPOINTS.REGI_GETSTUDENTNOTE]: (params, filterDates) => {
    const userName = params?.userName
    return `Regi_GetStudentNote/${userName}`;
  },
  [ENDPOINTS.REGI_GETSTUDENTS4ALLDAYVIEW]: (params, filterDates) => {
    const queryID = params?.queryID
    const date = params?.date
    const type = params?.type
    const teacher_username = params?.teacher_username
    const note_type_id = params?.note_type_id
    return `Regi_GetStudents4AllDayView/${queryID}/${date}/${type}/${teacher_username}/${note_type_id}`;
  },
  [ENDPOINTS.REGI_GETSTUDENTSBYTIMEBLOCKID]: (params, filterDates) => {
    const fromdate = filterDates?.fromDate
    const todate = filterDates?.toDate
    let filter = `/${fromdate}/${todate}`;
    const timeBlockId = params?.timeBlockId
    const teacher_username = params?.teacher_username
    const note_type_id = params?.note_type_id
    return `Regi_GetStudentsByTimeBlockId/${timeBlockId}/${teacher_username}/${note_type_id}${fromdate && todate ? filter : ""}`;
  },
  [ENDPOINTS.REGI_GETTIMEBLOCKSDATESBYCOURSEID]: (params, filterDates) => {
    const course_id = params?.course_id
    const days = params?.days
    return `Regi_GetTimeblocksDatesByCourseID/${course_id}/${days}`;
  },
  [ENDPOINTS.REGI_GETTIMEBLOCKSDATESBYSTUDENTID]: (params, filterDates) => {
    const student_id = params?.student_id
    const days = params?.days
    const merit = params?.merit
    const pause = params?.pause
    return `Regi_GetTimeblocksDatesByStudentID/${student_id}/${days}/${merit}/${pause}`;
  },
  [ENDPOINTS.REGI_GETTIMEBLOCKSDATESBYTEACHERID]: (params, filterDates) => {
    const teacher_id = params?.teacher_id
    const days = params?.days
    return `Regi_GetTimeblocksDatesByTeacherID/${teacher_id}/${days}`;
  },
  [ENDPOINTS.REGI_MARKSTUDENTS4ALLDAYVIEW]: (params, filterDates) => {
    return `Regi_MarkStudents4AllDayView/`;
  },
  [ENDPOINTS.REGI_SETSTUDENTNOTE]: (params, filterDates) => {
    const student_sis_id = params?.student_sis_id
    const author_sis_id = params?.author_sis_id
    const author_UserName = params?.author_UserName
    const author_DisplayName = params?.author_DisplayName
    const note_type = params?.note_type
    const tag_ids = params?.tag_ids
    return `Regi_SetStudentNote/${student_sis_id}/${author_sis_id}/${encodeURI(author_UserName)}/${encodeURI(author_DisplayName)}/${note_type}/${tag_ids}`;
  },
  [ENDPOINTS.REWARDUNUSEDDELETERESERVATION]: (params, filterDates) => {
    return `Reward_UnusedDeleteReservation/`;
  },
  [ENDPOINTS.SETBADGESACTIVE]: (params, filterDates) => {
    const id = params?.id
    return `SetBadgesActive/${id}`;
  },
  [ENDPOINTS.SETFILTER4USER]: (params, filterDates) => {
    const user_id = params?.user_id
    const filter_id = params?.filter_id
    return `SetFilter4User/${user_id}/${filter_id}`;
  },
  [ENDPOINTS.SETGUARDIAN4STUDENT]: (params, filterDates) => {
    return `SetGuardian4Student`;
  },
  [ENDPOINTS.SETLUDUSCASEWORKEREMAILREPORT]: (params, filterDates) => {
    return `SetLUDUS_CaseworkerEmailReport/`;
  },
  [ENDPOINTS.SETMANUELASSIGNMENTABSENCE]: (params, filterDates) => {
    return `SetManuelAssignmentAbsence`;
  },
  [ENDPOINTS.SET_TEAMSBOT_LANGUAGE]: (params, filterDates) => {
    const username = params?.username
    const language = params?.language
    return `set_TeamsBot_Language/${username}/${language}`;
  },
  [ENDPOINTS.SET_USERSETTING]: (params, filterDates) => {
    const username = params?.username
    const settingId = params?.settingId
    const value = params?.value
    const read_only = params?.read_only
    return `SetUser_Setting/${username}/${settingId}/${value}/${read_only}`;
  },
  [ENDPOINTS.SETUSERFAVORITES]: (params, filterDates) => {
    const username = params?.username
    const objectId = params?.objectId
    const type = params?.type
    return `SetUser_Favorites/${username}/${objectId}/${type}`;
  },
  [ENDPOINTS.STATS_GETABSENCEBYSTUDENTIDANDORTIMEBLOCKID]: (params, filterDates) => {
    const fromdate = filterDates?.fromDate
    const todate = filterDates?.toDate
    let filter = `/${fromdate}/${todate}`;
    const studentId = params?.studentId
    const timeblockId = params?.timeblockId
    return `Stats_GetAbsenceByStudentIDAndOrTimeBlockID/${studentId}/${timeblockId}${fromdate && todate?filter:""}`;
  },
  [ENDPOINTS.STUDENT_CHECKINOUT]: (params, filterDates) => {
    const studentId = params?.studentId
    const clientTimeZone = params?.clientTimeZone
    const checkInMethod = params?.checkInMethod
    const checkIn = params?.checkIn
    const lateMinutes = params?.lateMinutes
    const fixedLate = params?.fixedLate
    const debug = params?.debug
    const useMerit = params?.useMerit
    const usePause = params?.usePause
    return `Student_CheckInOut/${studentId}/${clientTimeZone}/${checkInMethod}/${checkIn}/${lateMinutes}/${fixedLate}/${debug}/${useMerit}/${usePause}`;
  },
  [ENDPOINTS.STUDENT_GETCHECKINOUT]: (params, filterDates) => {
    const studentId = params?.studentId
    const clientTimeZone = params?.clientTimeZone
    const checkInMethod = params?.checkInMethod
    return `Student_GetCheckInOut/${studentId}/${clientTimeZone}/${checkInMethod}`;
  },
  [ENDPOINTS.STUDENT_STAT_GETABSENCELOGSTUDENTDATE]: (params, filterDates) => {
    const studentId = params?.studentId
    const date = params?.date
    const timezone = params?.timezone
    return `Student_Stat_GetAbsenceLogStudentDate/${studentId}/${date}/${timezone}`;
  },
  [ENDPOINTS.STUDENT_STAT_GETABSENCETYPESPERCOURSE]: (params, filterDates) => {
    const fromdate = filterDates?.fromDate
    const todate = filterDates?.toDate
    let filter = `/${fromdate}/${todate}`;
    const studentId = params?.studentId
    return `Student_Stat_GetAbsenceTypesPerCourse/${studentId}${fromdate && todate?filter:""}`;
  },
  [ENDPOINTS.STUDENT_STAT_GETALLCOURSESCLASSIDS]: (params, filterDates) => {
    const fromdate = filterDates?.fromDate
    const todate = filterDates?.toDate
    let filter = `/${fromdate}/${todate}`;
    const studentId = params?.studentId
    return `Student_Stat_GetAllCoursesClassIDs/${studentId}${fromdate && todate?filter:""}`;
  },
  [ENDPOINTS.STUDENT_STAT_GETCOINS]: (params, filterDates) => {
    const studentId = params?.studentId
    const checkonly = params?.checkonly
    return `Student_Stat_GetCoins/${studentId}/${checkonly}`;
  },
  [ENDPOINTS.STUDENT_STAT_GETCOURSEDETAILS]: (params, filterDates) => {
    const fromdate = filterDates?.fromDate
    const todate = filterDates?.toDate
    let filter = `/${fromdate}/${todate}`;
    const classId = params?.classId
    const studentId = params?.studentId
    return `Student_Stat_GetCourseDetails/${classId}/${studentId}${fromdate && todate?filter:""}`;
  },
  [ENDPOINTS.STUDENT_STAT_GETCOURSEPERCENTAGE]: (params, filterDates) => {
    const fromdate = filterDates?.fromDate
    const todate = filterDates?.toDate
    let filter = `/${fromdate}/${todate}`;
    const studentId = params?.studentId
    const useMerit = params?.useMerit
    const usePause = params?.usePause
    return `Student_Stat_GetCoursePercentage/${studentId}/${useMerit}/${usePause}${fromdate && todate?filter:""}`;
  },
  [ENDPOINTS.STUDENT_STAT_GETDAYVIEWREGISTRATIONS]: (params, filterDates) => {
    const fromdate = filterDates?.fromDate
    const todate = filterDates?.toDate
    const student_id = params?.student_id
    return `Student_Stat_GetDayviewRegistrations/${student_id}/${fromdate}/${todate}`;
  },
  [ENDPOINTS.STUDENT_STAT_GETHEATMAPDETAILS]: (params, filterDates) => {
    const fromdate = filterDates?.fromDate
    const todate = filterDates?.toDate
    const useMerit = params?.useMerit
    const usePause = params?.usePause
    let filter = `/${fromdate}/${todate}`;
    const studentId = params?.studentId
    return `Student_Stat_GetHeatMapDetails/${studentId}/${useMerit}/${usePause}${fromdate && todate?filter:""}`;
  },
  [ENDPOINTS.STUDENT_STAT_GETREGISTRATIONS]: (params, filterDates) => {
    const fromdate = filterDates?.fromDate
    const todate = filterDates?.toDate
    let filter = `/${fromdate}/${todate}`;
    const studentId = params?.studentId
    return `Student_Stat_GetRegistrations/${studentId}${fromdate && todate?filter:""}`;
  },
  [ENDPOINTS.STUDENT_STAT_GETREWARDS]: (params, filterDates) => {
    const username = params?.username
    const language = params?.language
    return `Student_Stat_GetRewards/${username}/${language}`;
  },
  [ENDPOINTS.STUDENT_STAT_GETTOTALPERCENTAGE]: (params, filterDates) => {
    const fromdate = filterDates?.fromDate
    const todate = filterDates?.toDate
    let filter = `/${fromdate}/${todate}`;
    const studentId = params?.studentId
    const useMerit = params?.useMerit
    const usePause = params?.usePause
    return `Student_Stat_GetTotalPercentage/${studentId}/${useMerit}/${usePause}${fromdate && todate?filter:""}`;
  },
  [ENDPOINTS.STUDENT_STAT_GETTOTALPERCENTAGEDAY]: (params, filterDates) => {
    const fromdate = filterDates?.fromDate
    const todate = filterDates?.toDate
    let filter = `/${fromdate}/${todate}`;
    const studentId = params?.studentId
    const useMerit = params?.useMerit
    const usePause = params?.usePause
    return `Student_Stat_GetTotalPercentageDay/${studentId}/${useMerit}/${usePause}${fromdate && todate?filter:""}`;
  },
  [ENDPOINTS.TEACHER_STAT_COURSEPERCENTAGEOVERTIME]: (params, filterDates) => {
    const fromdate = filterDates?.fromDate
    const todate = filterDates?.toDate
    let filter = `/${fromdate}/${todate}`;
    const useMerit = params?.useMerit
    const usePause = params?.usePause
    return `Teacher_Stat_CoursePercentageOverTime/${useMerit}/${usePause}${fromdate && todate?filter:""}`;
  },
  [ENDPOINTS.TEACHER_STAT_GETCOURSEPERCENTAGE]: (params, filterDates) => {
    const fromdate = filterDates?.fromDate
    const todate = filterDates?.toDate
    let filter = `/${fromdate}/${todate}`;
    const teacherName = params?.teacherName
    const useMerit = params?.useMerit
    const usePause = params?.usePause
    return `Teacher_Stat_GetCoursePercentage/${teacherName}/${useMerit}/${usePause}${fromdate && todate?filter:""}`;
  },
  [ENDPOINTS.TEACHER_STAT_GETSTUDENTSABSENCE]: (params, filterDates) => {
    const fromdate = filterDates?.fromDate
    const todate = filterDates?.toDate
    let filter = `/${fromdate}/${todate}`;
    const teacherName = params?.teacherName
    const note_type_id = params?.note_type_id
    const useMerit = params?.useMerit
    const usePause = params?.usePause
    return `Teacher_Stat_GetStudentsAbsence/${teacherName}/${note_type_id}/${useMerit}/${usePause}${fromdate && todate ? filter : ""}`;
  },
  [ENDPOINTS.TEACHER_STAT_GETUNMARKEDLESSONS]: (params, filterDates) => {
    const fromdate = filterDates?.fromDate
    const todate = filterDates?.toDate
    const daysback = params?.daysback
    let filter = `/${fromdate}/${todate}`;
    const teacherName = params?.teacherName
    return `Teacher_Stat_GetUnmarkedLessons/${teacherName}${fromdate && todate?filter:("/" + daysback)}`;
  },
  [ENDPOINTS.GET_TEAMSBOT_PRESENCE]: (params, filterDates) => {
    const fromdate = filterDates?.fromDate
    const todate = filterDates?.toDate
    let filter = `/${fromdate}/${todate}`;
    const meetingId = params?.meetingId
    const timeblockId = params?.timeblockId
    const teacherUsername = params?.teacherUsername
    return `get_TeamsBot_Presence/${meetingId}/${timeblockId}/${teacherUsername}${fromdate && todate?filter:""}`;
  },
  [ENDPOINTS.UPDATEABSENCEREQEUST]: (params, filterDates) => {
    return `UpdateAbsenceRequest/`;
  },
  [ENDPOINTS.UPDATESTUDENTENTRY]: (params, filterDates) => {
    return `UpdateStudentEntry/`;
  },
  [ENDPOINTS.WONDEGETALLTAGS]: (params, filterDates) => {
    const date = params?.date
    return `WondeGetAllTags/`;
  },
  [ENDPOINTS.WRITTENSEARCH]: (params, filterDates) => {
    return `WrittenSearch`;
  },
};
